module.exports = __webpack_public_path__ + "static/img/cont52 (2).0994e88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont52 (2).jpg
// module id = HOTP
// module chunks = 0